/**
 * Kameleoon — Packshots in Variant Selectors (K53 Advance)
 * Body: kameleoon-packshots-b (packshots + original titles)
 *       kameleoon-packshots-c (packshots + Monats-Vorrat titles)
 * Theme Editor: data-packshot-src; CDN fallbacks in CSS.
 */
(function () {
  function qsa(root, sel) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function isPackshotsArm() {
    return (
      document.body.classList.contains('kameleoon-packshots-b') ||
      document.body.classList.contains('kameleoon-packshots-c')
    );
  }

  function hydrateTilePackshots() {
    if (!isPackshotsArm()) return;

    qsa(document, 'main.product .variant-packshot[data-packshot-src]').forEach(function (tile) {
      if (tile.dataset.packshotsHydrated === '1') return;
      var src = tile.getAttribute('data-packshot-src');
      if (!src) return;

      tile.dataset.packshotsHydrated = '1';
      tile.style.setProperty('--variant-packshot-url', "url('" + src + "')");

      var warm = new Image();
      warm.decoding = 'async';
      warm.src = src;
    });
  }

  function bind() {
    if (document.documentElement.dataset.packshotsBound === '1') return;
    document.documentElement.dataset.packshotsBound = '1';

    hydrateTilePackshots();
    new MutationObserver(hydrateTilePackshots).observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
